class CartDrawerRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-drawer').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-drawer-remove-button', CartDrawerRemoveButton);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    // Elements
    this.drawer = document.getElementById('cart-drawer');

    this.cartButton = document.querySelector('.js-open-cart');
    this.cartButton?.addEventListener('click', this.handleCartClick.bind(this));

    this.closeIcon = document.getElementById('cart-drawer__close');
    this.closeIcon.addEventListener('click', this.close.bind(this));

    this.onBodyClick = this.handleBodyClick.bind(this);
    this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    this.pageOverlayElement = document.querySelector('.page-overlay');

    // Functionality
    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  open() {
    this.drawer.setAttribute('aria-hidden', false);
    this.drawer.setAttribute('aria-expanded', true);

    this.pageOverlayElement.classList.add('is-visible');
    document.body.addEventListener('click', this.onBodyClick);

    document.body.classList.add('scroll-lock');
    this.onUpdateSplides();
  }

  close() {
    this.drawer.setAttribute('aria-hidden', true);
    this.drawer.removeAttribute('aria-expanded', true);

    this.pageOverlayElement.classList.remove('is-visible');
    document.body.removeEventListener('click', this.onBodyClick);

    document.body.classList.remove('scroll-lock');
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  onUpdateSplides() {
    setTimeout(() => {
      const reviews = document.querySelector('.cart-drawer-reviews-splide');
      if (reviews) {
        new Splide(reviews, {
          type: 'loop',
          perPage: 3,
          perMove: 1,
          gap: '1.25em',
          pagination: false,
          autoplay: true,
          arrows: false,
          pagination: true,
          focus: 'center',
        }).mount();
      }

      const saleSplide = document.querySelector('.sale-splide');
      if (saleSplide) {
        new Splide(saleSplide, {
          type: 'loop',
          perPage: 3,
          perMove: 1,
          gap: '12px',
          pagination: false,
          autoplay: false,
          arrows: false,
          breakpoints: {
            500: {
              perPage: 2,
            },
          },
        }).mount();
      }
    }, 500);
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        this.updateUpsells(parsedState);

        this.disableLoading();
      })
      .catch(() => {
        this.disableLoading();
      });
  }

  getSectionsToRender() {
    this.onUpdateSplides();
    return [
      {
        id: 'cart-drawer__content',
        section: document.getElementById('cart-drawer__content').dataset.id,
        selector: '.cart-drawer__content',
      },
      {
        id: 'cart-icon-bubble',
        section: 'header',
        selector: '.js-open-cart',
      },
      {
        id: 'cart-item-count',
        section: 'cart-drawer',
        selector: '#cart-item-count',
      },
      {
        id: 'cart-drawer__shipping-goal',
        section: 'cart-drawer',
        selector: '#cart-drawer__shipping-goal',
      },
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading() {
    document.getElementById('cart-drawer-loading')?.classList.remove('hidden');
  }

  disableLoading() {
    document.getElementById('cart-drawer-loading')?.classList.add('hidden');
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target.classList.contains('page-overlay')) {
      this.close();
      this.pageOverlayElement.classList.remove('is-visible');
    }
  }

  handleCartClick(evt) {
    evt.preventDefault();
    this.open();
  }

  updateUpsells(cart) {
    const upsellPrices = document.querySelectorAll('.product-upsell__button .price');
    let itemCount = 0;

    for (let item of cart.items) {
      if (item.product_type == 'The Elixir Mixer') {
        itemCount = itemCount + item.quantity;
      }
    }

    if (itemCount >= 2) {
      upsellPrices.forEach((price) => (price.innerHTML = '$52.80 each'));
    } else {
      upsellPrices.forEach((price) => (price.innerHTML = '$66 each'));
    }
  }
}

customElements.define('cart-drawer', CartDrawer);
